/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 7.36.0
 * source: common/pagination.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */
import * as pb_1 from "google-protobuf";
export namespace common.v1 {
    export class PaginationRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            pageIndex?: number;
            perPage?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("pageIndex" in data && data.pageIndex != undefined) {
                    this.pageIndex = data.pageIndex;
                }
                if ("perPage" in data && data.perPage != undefined) {
                    this.perPage = data.perPage;
                }
            }
        }
        get pageIndex() {
            return pb_1.Message.getFieldWithDefault(this, 1, 0) as number;
        }
        set pageIndex(value: number) {
            pb_1.Message.setField(this, 1, value);
        }
        get perPage() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set perPage(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            pageIndex?: number;
            perPage?: number;
        }): PaginationRequest {
            const message = new PaginationRequest({});
            if (data.pageIndex != null) {
                message.pageIndex = data.pageIndex;
            }
            if (data.perPage != null) {
                message.perPage = data.perPage;
            }
            return message;
        }
        toObject() {
            const data: {
                pageIndex?: number;
                perPage?: number;
            } = {};
            if (this.pageIndex != null) {
                data.pageIndex = this.pageIndex;
            }
            if (this.perPage != null) {
                data.perPage = this.perPage;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.pageIndex != 0)
                writer.writeUint32(1, this.pageIndex);
            if (this.perPage != 0)
                writer.writeUint32(2, this.perPage);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PaginationRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PaginationRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.pageIndex = reader.readUint32();
                        break;
                    case 2:
                        message.perPage = reader.readUint32();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): PaginationRequest {
            return PaginationRequest.deserialize(bytes);
        }
    }
    export class PaginationResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            pageIndex?: number;
            perPage?: number;
            totalCount?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("pageIndex" in data && data.pageIndex != undefined) {
                    this.pageIndex = data.pageIndex;
                }
                if ("perPage" in data && data.perPage != undefined) {
                    this.perPage = data.perPage;
                }
                if ("totalCount" in data && data.totalCount != undefined) {
                    this.totalCount = data.totalCount;
                }
            }
        }
        get pageIndex() {
            return pb_1.Message.getFieldWithDefault(this, 1, 0) as number;
        }
        set pageIndex(value: number) {
            pb_1.Message.setField(this, 1, value);
        }
        get perPage() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set perPage(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        get totalCount() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set totalCount(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            pageIndex?: number;
            perPage?: number;
            totalCount?: number;
        }): PaginationResponse {
            const message = new PaginationResponse({});
            if (data.pageIndex != null) {
                message.pageIndex = data.pageIndex;
            }
            if (data.perPage != null) {
                message.perPage = data.perPage;
            }
            if (data.totalCount != null) {
                message.totalCount = data.totalCount;
            }
            return message;
        }
        toObject() {
            const data: {
                pageIndex?: number;
                perPage?: number;
                totalCount?: number;
            } = {};
            if (this.pageIndex != null) {
                data.pageIndex = this.pageIndex;
            }
            if (this.perPage != null) {
                data.perPage = this.perPage;
            }
            if (this.totalCount != null) {
                data.totalCount = this.totalCount;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.pageIndex != 0)
                writer.writeUint32(1, this.pageIndex);
            if (this.perPage != 0)
                writer.writeUint32(2, this.perPage);
            if (this.totalCount != 0)
                writer.writeUint32(3, this.totalCount);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PaginationResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PaginationResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.pageIndex = reader.readUint32();
                        break;
                    case 2:
                        message.perPage = reader.readUint32();
                        break;
                    case 3:
                        message.totalCount = reader.readUint32();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): PaginationResponse {
            return PaginationResponse.deserialize(bytes);
        }
    }
}
